module.exports = __webpack_public_path__ + "static/media/plus.c3b7ce8f.png";